'use client'
import styled from 'styled-components';
import {Black, hover, text, title, White} from '@/styles/globalStyleVars'
import Link from "next/link";
import {Img} from "@/components/Img";
import reactHtmlParser from "react-html-parser";

const ProjectBox = ({title, link, date,  category}) => {
    return (
        <StyledProjectBox>
            <div className="wrapper">
                <Link href={`${link ? link : '#'}`}  prefetch={true} target={'_blank'}/>
                <div className="date-cat">
                    {
                        date &&
                        <p>{reactHtmlParser(date)}</p>
                    }

                    {
                        category &&
                        <p>{category}</p>

                    }
                </div>
                <div className="title-download">
                    {
                        title &&
                        <h6>{title}</h6>
                    }

                    <div className="download-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16.914" height="14.414"
                             viewBox="0 0 16.914 14.414">
                            <g id="Arrow" transform="translate(4163.914 -258.086) rotate(90)">
                                <line id="Line_12481" data-name="Line 12481" x2="7" y2="7"
                                      transform="translate(259.5 4148.5)" fill="none" stroke="#fff"
                                      strokeLinecap="round" strokeWidth="2"/>
                                <line id="Line_12482" data-name="Line 12482" yv1="7" x2="7"
                                      transform="translate(259.5 4155.5)" fill="none" stroke="#fff"
                                      strokeLinecap="round" strokeWidth="2"/>
                                <line id="Line_12503" data-name="Line 12503" x2="14"
                                      transform="translate(271.5 4162) rotate(-90)" fill="none" stroke="#fff"
                                      strokeLinecap="round" strokeWidth="2"/>
                            </g>
                        </svg>

                    </div>
                </div>
            </div>
        </StyledProjectBox>

    )
};


const StyledProjectBox = styled.div`

    .wrapper{
        display: flex;
        flex-direction: column;
        padding: 30px 30px 50px 30px;
        border: 1px solid #191919;
        position: relative;
        a{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 5;
        }
        
        &:before{
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 0;
            background-color: ${Black};
            transition: 0.5s ease-in-out;
            z-index: 1;
        }
        .date-cat{
            display: flex;
            justify-content: space-between;
            position: relative;
            z-index: 1;
            p{
                font-size: 12px;
                line-height: 20px;
                color: rgba(25,25,25,0.5);
            }
            margin-bottom: 15px;
        }
        
        .title-download{
            display: flex;
            justify-content: space-between;
            gap: 15px;
            position: relative;
            z-index: 1;
            h6{
                font-size: 16px;
                line-height: 20px;
                color: #191919;
                width: calc(100% - 30px);
            }
            
            .download-btn{
                height: 30px;
                width: 30px;
                background-color: ${hover};
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                &:after{
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: 100%;
                    width: 0;
                    background-color: ${White};
                    transition: 0.5s ease-in-out;
                    z-index: 1;
                }
                svg{
                    position: relative;
                    z-index: 2;
                }
            }
        }
        &:hover{
            &:before{
                width: 100%;
            }
            
            h6{
                color: ${White};
            }
            p{
                color: rgba(255,255,255,0.5);
            }
            
            .download-btn{
                
                svg{
                    line{
                        stroke: ${hover};
                    }
                }
                &:after{
                    width: 100%;
                }
            }
        }
    }
`;

export default ProjectBox;














